export enum CompanyFields {
  companyId = "companyId",
  name = "name",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}
